export default __webpack_public_path__ + "static/media/busLane.eeeb4255.svg";